<div class="main-container" (document:click)="handleOutsideClick($event)">
  <div>
    <input 
      type="text" 
      class="input" 
      [placeholder]="placeHolder" 
      [(ngModel)]="value" 
      (focus)="onFocus()" 
      (input)="onInput()"
    >
  </div>

  <div class="dropdown-list" *ngIf="dropdownVisible && value === ''">
    <div class="item" *ngFor="let item of dropdownValues" (click)="selectItem(item)">
      <p class="value">{{ item.name }}</p>
    </div>
  </div>
</div>
